module.exports = __webpack_public_path__ + "static/media/spotify-logo.12f69deb.png";